/**
 * Provides a enumerations for common actions used in the emr-table component.
 */
export enum ActionName {
  Create = 'Create',
  Update = 'Edit',
  Delete = 'Delete',
  Navigate = 'Navigate',
}
